import type { DirectiveBinding } from 'vue/types/options'
import type { DirectiveOptions } from 'vue'

const ativos = new WeakMap<HTMLElement, boolean>()

type CampoDeTexto = HTMLInputElement | HTMLTextAreaElement

function campoDeTexto(el: HTMLElement): CampoDeTexto | null {
	if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) return el
	return el.querySelector<CampoDeTexto>('input, textarea')
}

function estaAtivo(binding: DirectiveBinding): boolean {
	return binding.value !== false
}

function aplicar(campo: CampoDeTexto) {
	const emMaiusculo = campo.value.toUpperCase()
	if (campo.value === emMaiusculo) return

	const inicioDaSelecao = campo.selectionStart
	const fimDaSelecao = campo.selectionEnd

	campo.value = emMaiusculo

	if (inicioDaSelecao !== null && fimDaSelecao !== null) {
		try {
			campo.setSelectionRange(inicioDaSelecao, fimDaSelecao)
		} catch (e) {
			// tipos de input sem suporte a selecao (email, number) lancam aqui
		}
	}

	campo.dispatchEvent(new Event('input'))
}

export const maiusculo: DirectiveOptions = {
	inserted(el, binding) {
		const campo = campoDeTexto(el)
		if (!campo) return

		ativos.set(el, estaAtivo(binding))

		campo.addEventListener('input', () => {
			if (ativos.get(el)) aplicar(campo)
		})

		if (ativos.get(el)) aplicar(campo)
	},

	componentUpdated(el, binding) {
		ativos.set(el, estaAtivo(binding))

		const campo = campoDeTexto(el)
		if (campo && ativos.get(el)) aplicar(campo)
	},
}

export default maiusculo
